/* eslint-disable import/prefer-default-export */
export const ADMIN_ROLES_SURVEY_DISMISSED_COOKIE_NAME = 'admin-roles-survey-dismissed';

export const ROUTE_NAMES = {
  analytics: 'analytics',
  analytics_v1: 'analytics-v1',
  appearance: 'appearance',
  billing: 'billing',
  bulkEnrollment: 'enrollment',
  bulkEnrollmentResults: 'bulk-enrollment-results',
  codeManagement: 'coupons',
  contentHighlights: 'content-highlights',
  learners: 'learners',
  learners_v2: 'learners-v2',
  learnerCredit: 'learner-credit',
  peopleManagement: 'people-management',
  reporting: 'reporting',
  settings: 'settings',
  subscriptionManagement: 'subscriptions',
};

export const PRODUCT_TYPES = {
  ESSENTIALS: 'Essentials',
  TEAMS: 'Teams',
};

export const BUDGET_STATUSES = {
  active: 'Active',
  expired: 'Expired',
  expiring: 'Expiring',
  scheduled: 'Scheduled',
  retired: 'Retired',
};

export const BUDGET_TYPES = {
  ecommerce: 'ecommerce',
  subsidy: 'subsidy',
  policy: 'policy',
};
